module.exports = __webpack_public_path__ + "static/media/payNowScreen.e770a0b9.png";